import React, { useEffect, useState } from "react";
import { Card, Form, Row, Col, Table, Button, Input, Space, Tooltip, Modal, Spin } from "antd";
import { useHistory, useRouteMatch } from "react-router-dom";
import { LinkOutlined } from "@ant-design/icons";
import LocalStorageService from "../../../../services/LocalStorageService";
import { hasAccess } from "../../hasAccess";
import {
  MENU_USER_USERMANAGEMENT,
  MENU_USER_USERMANAGEMENT_WRITE,
  USERMANAGEMENT_USER_CREATE,
} from "../../../../lib/const/permissions";
import { ReactComponent as DisabledIcon } from "../../img/disabled_icon.svg";
import { uniqueId } from "lodash";
import { FormInfo } from "../../../common/FormInfo/FormInfo";
import { useLoading } from "../../../../lib/hooks/useLoading";

const selectStyle = {
  marginTop: "9px",
};

const defaultFormValues = {
  tenantId: LocalStorageService.getTenantId(),
  firstName: "",
  lastName: "",
  middleName: "",
  email: ".", // Изначально с точкой, иначе замещается содержимым кэша
  login: ".", // Изначально с точкой, иначе замещается содержимым кэша
  password: ".", // Изначально с точкой, иначе замещается содержимым кэша
};

export default function RolesTabUsers(props) {
  const {
    handleChangeUsersPage,
    handleCreateUser,
    handlePageableSearch,
    users,
    usersLoading,
    usersTotal,
    fetchUsers,
    userTablePage,
    requirements,
  } = props;
  const { url } = useRouteMatch();

  const history = useHistory();
  const [form] = Form.useForm();
  const [searchForm] = Form.useForm();
  const [visibleModalWindow, setVisibleModalWindow] = useState(false);
  const [passwordError, setPasswordError] = useState(""); // Состояние для ошибки пароля
  const dataSource = users.map((item) => ({
    key: item.id,
    lastName: item.lastName,
    firstName: item.firstName,
    middleName: item.middleName,
    login: item.login,
    email: item.email,
    userType: item.userType,
    enabled: item.enabled,
    temporaryLocked: item.temporaryLocked,
  }));

  const { isLoading, startLoading, stopLoading } = useLoading();

  const showModalAddUser = () => {
    startLoading();
    setVisibleModalWindow(true);
    form.setFieldsValue(defaultFormValues);
    setTimeout(() => {
      stopLoading();
      // Сброс значений через секунду, чтобы затереть прилетающее из кэша
      form.setFieldsValue({ email: "", login: "", password: "" });
    }, 1000);
    setPasswordError(""); // Сброс ошибки при открытии окна
  };

  const hideModalAddUser = () => {
    form.resetFields();
    setVisibleModalWindow(false);
  };

  useEffect(() => {
    fetchUsers(userTablePage);
  }, [userTablePage]);

  const renderSideCard = () => {
    const onFinish = (values) => {
      handlePageableSearch(values);
    };
    const onReset = () => {
      fetchUsers();
      searchForm.resetFields();
    };

    return (
      <Card style={{ boxShadow: "1px 1px 5px rgb(0 0 0 / 16%)" }}>
        <Form
          name="pageableSearch"
          form={searchForm}
          onFinish={onFinish}
          onReset={onReset}
          initialValues={{
            lastName: "",
            firstName: "",
            login: "",
            email: "",
          }}
        >
          <span className="form__label">Фамилия</span>
          <Form.Item name="lastName">
            <Input style={selectStyle} />
          </Form.Item>
          <span className="form__label">Имя</span>
          <Form.Item name="firstName">
            <Input style={selectStyle} />
          </Form.Item>
          <span className="form__label">Логин</span>
          <Form.Item name="login">
            <Input style={selectStyle} />
          </Form.Item>
          <span className="form__label">E-mail</span>
          <Form.Item name="email">
            <Input style={selectStyle} />
          </Form.Item>
          <Form.Item>
            <Row justify="space-around">
              <Col>
                <Button htmlType="reset">Сбросить</Button>
              </Col>
              <Col>
                <Button type="primary" htmlType="submit">
                  Применить
                </Button>
              </Col>
            </Row>
          </Form.Item>
        </Form>
      </Card>
    );
  };

  const getTitle = (row) => {
    let title = "";

    if (row.enabled === false) {
      title = "Пользователь отключен";
    }

    if (row.temporaryLocked) {
      title = "Пользователь заблокирован";
    }

    return title;
  };

  const renderTable = () => {
    const columns = [
      {
        title: "Фамилия",
        dataIndex: "lastName",
        key: "lastName",
        width: "25%",
        render: (text, row) => (
          <Space>
            <div
              style={{
                width: 13,
              }}
            >
              {row.userType === "internal" && (!row.enabled || row.temporaryLocked) && (
                <Tooltip title={getTitle(row)}>
                  <DisabledIcon />
                </Tooltip>
              )}
            </div>
            <div
              style={{
                width: 13,
              }}
            >
              {row.userType === "external" && (
                <Tooltip title="Для уточнения привилегий пользователя обратитесь к Администратору AD">
                  <LinkOutlined />
                </Tooltip>
              )}
            </div>
            {row.lastName}
          </Space>
        ),
      },
      {
        title: "Имя",
        dataIndex: "firstName",
        key: "firstName",
        width: "15%",
      },
      {
        title: "Отчество",
        dataIndex: "middleName",
        key: "middleName",
        width: "20%",
      },
      {
        title: "Логин",
        dataIndex: "login",
        key: "login",
        width: "20%",
      },
      {
        title: "E-mail",
        dataIndex: "email",
        key: "email",
        width: "20%",
      },
    ];
    return (
      <Table
        columns={columns}
        dataSource={dataSource}
        loading={usersLoading}
        size="small"
        onRow={(record) => ({
          onClick: () => {
            if (hasAccess(MENU_USER_USERMANAGEMENT, MENU_USER_USERMANAGEMENT_WRITE)) {
              history.push(`${url}/${record.key}/profile`);
            }
          },
        })}
        pagination={{
          hideOnSinglePage: true,
          defaultPageSize: 16,
          onChange: handleChangeUsersPage,
          position: ["bottomCenter"],
          total: usersTotal,
          current: userTablePage + 1,
        }}
      />
    );
  };

  const renderModalWindow = () => {
    const onFinish = (values) => {
      handleCreateUser(values).then((res) => {
        if (res?.status) {
          hideModalAddUser();
        }

        if (res?.status === false) {
          // Для других ошибок закрываем окно
          setPasswordError(res.error.response.data.message || "Ошибка создания пользователя");
        }
      });
    };
    return (
      <Modal
        visible={visibleModalWindow}
        footer={null}
        title="Создание нового пользователя"
        onCancel={hideModalAddUser}
      >
        <Spin spinning={isLoading}>
          <Form
            form={form}
            name="basic"
            initialValues={defaultFormValues}
            labelCol={{ span: 5 }}
            labelAlign="left"
            onFinish={onFinish}
            onValuesChange={() => {
              setPasswordError("");
            }}
          >
            <Form.Item label="Фамилия" name="lastName">
              <Input placeholder="Введите фамилию" />
            </Form.Item>

            <Form.Item label="Имя" name="firstName">
              <Input placeholder="Введите имя" />
            </Form.Item>
            <Form.Item label="Отчество" name="middleName">
              <Input placeholder="Введите отчество" />
            </Form.Item>
            <Form.Item
              label="Логин"
              name="login"
              rules={[{ required: true, message: "Пожалуйста, введите логин" }]}
            >
              <Input placeholder="Введите логин" />
            </Form.Item>
            <Form.Item
              label="Пароль"
              name="password"
              rules={[{ required: true, message: "Пожалуйста, введите пароль" }]}
            >
              <Input placeholder="Введите пароль" />
            </Form.Item>
            <Form.Item
              label="E-mail"
              name="email"
              rules={[
                { required: true, message: "Пожалуйста, введите e-mail" },
                {
                  type: "email",
                  message: "Пожалуйста, введите корректный e-mail",
                },
              ]}
            >
              <Input placeholder="Введите e-mail" />
            </Form.Item>
            <Form.Item style={{ paddingTop: "20px" }}>
              <Row gutter={[14, 16]} justify="center">
                <Col>
                  <Button key="add" onClick={hideModalAddUser}>
                    Отмена
                  </Button>
                </Col>
                <Col>
                  <Button key="delete" type="primary" htmlType="submit">
                    Сохранить
                  </Button>
                </Col>
              </Row>
            </Form.Item>
          </Form>
        </Spin>
        <FormInfo getFormValues={form.getFieldsValue} />
      </Modal>
    );
  };

  return (
    <>
      {renderModalWindow()}
      <Row justify="end">
        <Col>
          {hasAccess(MENU_USER_USERMANAGEMENT_WRITE, USERMANAGEMENT_USER_CREATE) && (
            <Button key="add" type="primary" onClick={showModalAddUser}>
              Добавить пользователя
            </Button>
          )}
        </Col>
      </Row>
      <Row style={{ marginTop: "16px" }} gutter={[8, 8]}>
        <Col flex="0 1 290px">{renderSideCard()}</Col>
        <Col flex="1 1 200px">{renderTable()}</Col>
      </Row>
    </>
  );
}
